import { render, staticRenderFns } from "./historicalAddresses.vue?vue&type=template&id=75b777ec&scoped=true&"
import script from "./historicalAddresses.vue?vue&type=script&lang=js&"
export * from "./historicalAddresses.vue?vue&type=script&lang=js&"
import style0 from "./historicalAddresses.vue?vue&type=style&index=0&id=75b777ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b777ec",
  null
  
)

export default component.exports